import { Splash } from 'core/styles/Banner'
import styled, { css } from 'styled-components'
import { lighter } from '../helpers/color'
import { breakpoint } from '../layout/styles'
import { Container } from '../styles/Container'
import { Grid, Cell } from '../styles/Grid'
import ReactHtmlParser from 'react-html-parser'
import { formatAsterisk } from '../helpers/string'

const Categories = ({ data }: any) => (
  <Background url={data.background?.url ? `${data.background.url}?width=${480}&auto=webp&format=png` : undefined}>
    <Wrapper vertical={data.vertical}>
      <Grid>
        {data.items.map((item: any) => (
          <Section
            key={item._metadata.uid}
            bg={item.background_color?.[0]?.background}
            horizontal={data.horizontal}
            vertical={data.vertical}>
            {item.image && (
              <img
                alt={item.title}
                src={`${item.image.url}?width=${350}&auto=webp&format=png`}
                width={350}
                height={350}
              />
            )}
            <h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: formatAsterisk(item.title, 'strong')
                }}
              />
            </h2>
            <div style={{ padding: '0 24px' }}>{ReactHtmlParser(formatAsterisk(item.description, 'i'))}</div>
            {item.cta && item.cta.href && (
              <Cta href={item.cta.href} aria-label={`${item.cta.title} about ${item.title.replace(/\*/g, '')}`}>{item.cta.title}</Cta>
            )}
          </Section>
        ))}
      </Grid>
    </Wrapper>
  </Background>
)

export default Categories

const Wrapper = styled(Container)`
  color: var(--text);
  margin: 1.5rem;
  background: ${(props) => props.background || 'none'};
  @media ${breakpoint.desktop} {
    padding: 20px;
    margin: 0 auto 48px;
    padding: 0;
    background: none;
  }
  ${(props) =>
    props.vertical &&
    css`
      ${Grid} {
        flex-direction: column;
      }
    `}
`

export const Background = styled.div<any>`
  background: transparent none no-repeat scroll center right;
  background-size: contain;
  @media (min-width: 1440px) {
    background-image: url(${(props) => props.url});
  }
`

export const Cta = styled.a`
  display: inline-block;
  cursor: pointer;
  background: #000;
  color: white;
  text-transform: uppercase;
  padding: 10px 20px;
  margin-top: 50px;
  text-decoration: none;
`

export const Section = styled(Cell)`
  text-align: center;
  margin: 16px 0;
  @media ${breakpoint.desktop} {
    ${(props) =>
      props.horizontal &&
      css`
        --section-direction: ${props.horizontal ? 'row' : 'column'};
        --section-padding: ${props.horizontal ? '0' : '50px'};
      `}
  }
  padding-bottom: var(--section-padding, 50px);
  flex-direction: column;
  @media ${breakpoint.desktop} {
    flex-direction: var(--section-direction, column);
    width: 33.3333%;
    margin: 0 18px 48px;
  }
  ${(props) =>
    props.vertical &&
    css`
      @media ${breakpoint.desktop} {
        width: 100%;
        margin: 0 0 48px;
      }
      &&& {
        h2 {
          text-align: left;
          align-items: flex-start;
          @media ${breakpoint.desktop} {
            padding-left: 24px;
            padding-right: 25px;
          }
        }
      }
    `}
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  img {
    display: block;
    margin: 0 auto;
  }
  h2 {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    margin: 16px 10px;
    ${(props) =>
      props.bg &&
      css`
        --header-background: ${props.bg};
      `}
  }
  &:after {
    ${(props) =>
      props.bg &&
      css`
        --card-background: ${props.bg};
      `}
  }
  p {
    font-size: 14px;
    @media ${breakpoint.desktop} {
      font-size: 16px;
    }
  }
  img {
    width: 100%;
    object-fit: cover;
  }
`
const SectionTitle = styled.h3`
  margin: 16px 0;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  @media ${breakpoint.desktop} {
    margin: 48px 0 0 0;
    font-size: 36px;
  }
`
